import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

import Icon from "@mui/material/Icon"

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";



import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import PageTitle from "components/PageTitle";

import * as ajax from "helpers/ajax";
import styles from "./index.module.css";
import html2pdf from 'html2pdf.js'
import { PATH, ROLES } from "../../constant";
import CircularProgress from '@mui/material/CircularProgress';
import CalendarIcon from 'components/CalendarIcon'
import { IFrame } from '../../iframe'
import { newWorkerPrice, toPrice } from "../../helpers/functions";



const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const weekNames = ["D", "L", "M", "M", "G", "V", "S"]



export default class Report extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            workers: [],

            selectedDay: new Date(),
            loading: false,
        };
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;
        this.csv = [[]];
    }

    componentDidMount = () => {
        this.load()


    }

    load = () => {
        //ajax.ajaxGetStrapi("operai-commesses?sort=data&filters[data][$gte]="+this.firstDayOfMonth()+"&filters[data][$lte]="+this.lastDayOfMonth()+"&populate=commessa&populate=operaio.societa" , this.loadCallback)
        this.setState({ loading: true });
        this.csv = [[]];
        fetch(PATH + "operai-commesses?sort=data&filters[data][$gte]=" + this.firstDayOfMonth() + "&filters[data][$lte]=" + this.lastDayOfMonth() + "&populate[operaio][populate][societa]=societa&populate[commessa][fields][0]=nome", {
            method: "GET",
            signal:this.fetchSignal,
            headers: {
                Authorization: `Bearer ${global.jwt}`,
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.loadCallback(responseJson)
            })
            .catch((error) => {
                console.log(error);
                //Catch Service Error
            });

    }

    loadCallback = (response) => {

        //response.data.sort((a, b) => (a.operaio.societa && b.operaio.societa) ? ((a.operaio.societa.nome > b.operaio.societa.nome) ? 1 : ((b.operaio.societa.nome > a.operaio.societa.nome) ? -1 : 0)) : 0)

        let responseData = []
        response.data.map((el) => {
            if (!el.operaio) {return}
            if (!el.commessa) {return}
            if (!el.operaio.societa) {
                el.operaio.societa = { "nome": "Nessuna società" }
            }

            let data = {}
            let index = responseData.findIndex(e => e.id === el.operaio.id)

            if (index > -1) {

                if (!responseData[index]["working-day"][el.data]) { responseData[index]["working-day"][el.data] = [] }
                responseData[index]["working-day"][el.data].push({
                    ore: el.ore,
                    stato: el.stato,
                    commessa: el.commessa.nome,
                    costo_orario: el.costo_orario,
                    operaio:el.operaio,
                    filler:el.filler
                })

                if (el.commessa.nome != responseData[index]["commessa"][responseData[index]["commessa"].length - 1]) {
                    responseData[index]["commessa"].push(el.commessa.nome)
                }

            } else {
                data["id"] = el.operaio.id
                data["nome"] = el.operaio.nome
                data["cognome"] = el.operaio.cognome
                data["societa"] = el.operaio.societa.nome
                data["commessa"] = [];
                data["commessa"].push(el.commessa.nome)

                data["working-day"] = {} 
                data["working-day"][el.data] = [] 
                data["working-day"][el.data].push({
                    ore: el.ore,
                    stato: el.stato,
                    commessa: el.commessa.nome,
                    costo_orario: el.costo_orario,
                    operaio:el.operaio,
                    filler:el.filler
                })
                responseData.push(data);
            }
        })

        this.setState({ workers: responseData, loading: false })
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }


    lastDayOfMonth = () => {
        let date = new Date(this.state.selectedDay.getFullYear(), this.state.selectedDay.getMonth()+1, 0)
        return this.convertDate(date)
    }

    firstDayOfMonth = () => {
        let date = new Date(this.state.selectedDay.getFullYear(), this.state.selectedDay.getMonth(),1)
        return this.convertDate(date)
    }

    changeMonth = (n) => {
        let date = this.state.selectedDay
        date.setMonth(date.getMonth() + n);

        this.fetchController.abort();
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;

        this.setState({ selectedDay: date }, this.load)
    }

    setDate = (val) => {
        let date = new Date(val)

        this.fetchController.abort();
        this.fetchController = new AbortController();
        this.fetchSignal = this.fetchController.signal;

        this.setState({ selectedDay: date }, this.load)
    }

    renderCalendar = () => {
        return (
            <>
                <Grid container justifyContent={"space-between"} alignItems={"center"} >
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                    </Grid>
                    <Grid item>
                        <MDTypography variant={"h3"} mr={2}>
                            <CalendarIcon onChange={(val) => this.setDate(val)} style={{ verticalAlign: "middle" }} />
                            {monthNames[this.state.selectedDay.getMonth()]}{" "}{this.state.selectedDay.getFullYear()}
                        </MDTypography>
                    </Grid>
                    <Grid item>
                        <MDButton variant="text" color="dark" onClick={() => this.changeMonth(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                    </Grid>
                </Grid>
            </>
        );
    }

    csvAdd = (i, v) => {
        if (!this.csv[i]) { this.csv[i] = [] }
        if (v == null) { v = "" }
        this.csv[i].push(v)
    }

    renderTableHeader = (worker, first=null) => {

        let days = []

        let firstDay = new Date(this.firstDayOfMonth())
        let lastDay = new Date(this.lastDayOfMonth())
        firstDay.setHours(0, 0, 0, 0);
        lastDay.setHours(0, 0, 0, 0);

        while (firstDay <= lastDay) {
            days.push(weekNames[firstDay.getDay()]);
            firstDay.setDate(firstDay.getDate() + 1);
        }

        this.csv[0] = ["N.", "Nominativo",""];
        this.csv[1] = ["", "",""];

        return (
            
            <tbody key={worker.societa} className={first?"":"page-break"}>
                <tr>
                    <th colSpan="100%">
                        <MDTypography variant={"h4"} textTransform={"uppercase"}>{worker.societa}</MDTypography>
                    </th>
                </tr>
                <tr>
                    <td rowSpan={2}><MDTypography variant={"caption"} fontWeight={"bold"}>N.</MDTypography></td>
                    <td rowSpan={2}><MDTypography variant={"caption"} fontWeight={"bold"}>Nominativo</MDTypography></td>
                    <td rowSpan={2}></td>
                    {days.map((el, index) => {
                        return (
                            <td key={"weeknames" + index}>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>
                                    {el}
                                    {this.csvAdd(0,el)}
                                </MDTypography>
                            </td>
                        )
                    })}
                    <td rowSpan={2}><MDTypography variant={"caption"} fontWeight={"bold"}>TOT. h</MDTypography></td>
                    {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                        <td rowSpan={2}><MDTypography variant={"caption"} fontWeight={"bold"}>TOT. costo</MDTypography></td> : null}
                </tr>
                <tr>
                    {days.map((el, index) => {
                        return (
                            <td key={"weekdays" + index}>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>
                                    {index < 9 ? "0" + (index + 1).toString() : index + 1}
                                    {this.csvAdd(1, index < 9 ? "0" + (index + 1).toString() : (index + 1).toString())}
                                </MDTypography>
                            </td>
                        )
                    })}
                    {this.csvAdd(1, "TOT. h")}
                    {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ? this.csvAdd(1, "TOT. costo") : null}
                </tr>
            </tbody>
        )
    }


    renderWorkerRow = (worker, index, iframe=false) => {
        let csvOffset = 2;
        let csvNumRow = 6;

        let days = []
        let firstDay = new Date(this.firstDayOfMonth())
        let lastDay = new Date(this.lastDayOfMonth())
        firstDay.setHours(0, 0, 0, 0);
        lastDay.setHours(0, 0, 0, 0);

        while (firstDay <= lastDay) {
            days.push(weekNames[firstDay.getDay()]);
            firstDay.setDate(firstDay.getDate() + 1);
        }

        let arr = []

        if (index == 0) {
            arr.push(this.renderTableHeader(worker, true));
        }

        if (index > 0) {
            if (this.state.workers[index].societa != this.state.workers[index - 1].societa) {
                arr.push(this.renderTableHeader(worker));
            }
        }

        let sumOrd = 0;
        let sumStraord = 0;
        let sumPerm = 0;
        let sumNotturno = 0;

        let sumOrdPrezzo = 0;
        let sumStraordPrezzo = 0;
        let sumPermPrezzo = 0;
        let sumNotturnoPrezzo = 0;

        let skipCol = 0;
        let lastCommessa = null;

        arr.push(
            <>
                <tbody key={"worker-row-" + index}>
                    <tr>
                        <td rowSpan={5}>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{index + 1}</MDTypography>
                            {(iframe) ?this.csvAdd(csvOffset + ((index) * csvNumRow), index + 1): null}
                        </td>
                        <td rowSpan={5}>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{worker.nome}{" "}{worker.cognome}</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + ((index) * csvNumRow), worker.nome + " " + worker.cognome) : null}
                        </td>

                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>O</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + ((index) * csvNumRow), "O") : null}
                        </td>
                        {days.map((el, j) => {
                            let n = this.sumWorkerHours2(worker, j, "ORDINARIO");
                            sumOrd += parseFloat(n[0])
                            sumOrdPrezzo += parseFloat(n[2])
                            return (
                                <td key={"ordinario-" + index + "-" + j}>
                                    <MDTypography variant={"caption"} style={(n[3]<8)?{color:"red", fontWeight:"bold"}:{}}>{n[1]}</MDTypography>
                                    {(iframe) ? this.csvAdd(csvOffset + ((index) * csvNumRow), n[1]) : null}
                                </td>
                            )
                        })}
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{sumOrd}</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + ((index) * csvNumRow), sumOrd) : null}

                        </td>
                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                            <td>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>{toPrice(sumOrdPrezzo)}</MDTypography>
                                {(iframe) ? this.csvAdd(csvOffset + ((index) * csvNumRow), sumOrdPrezzo) : null}

                            </td>
                            : null}
                    </tr>
                    <tr>
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>S</MDTypography>
                            {(iframe) ?this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), "S"):null}
                        </td>
                        {days.map((el, j) => {
                            let n = this.sumWorkerHours2(worker, j, "STRAORDINARI ");
                            sumStraord += parseFloat(n[0])
                            sumStraordPrezzo += parseFloat(n[2])
                            return (
                                <td key={"straordinario-" + index + "-" + j}>
                                    <MDTypography variant={"caption"}>{n[1]}</MDTypography>
                                    {(iframe) ?this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), n[1]):null}
                                </td>
                            )
                        })}
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{sumStraord}</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), sumStraord) : null}
                        </td>
                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                            <td>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>{toPrice(sumStraordPrezzo)}</MDTypography>
                                {(iframe) ? this.csvAdd(csvOffset + 1 + ((index) * csvNumRow), sumStraordPrezzo) : null}
                            </td> : null}
                    </tr>
                    <tr>
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>N</MDTypography>
                            {(iframe) ?this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), "N"):null}
                        </td>
                        {days.map((el, j) => {
                            let n = this.sumWorkerHours2(worker, j, "NOTTURNO");
                            sumNotturno += parseFloat(n[0])
                            sumNotturnoPrezzo += parseFloat(n[2])
                            return (
                                <td key={"notturno-" + index + "-" + j}>
                                    <MDTypography variant={"caption"}>{n[1]}</MDTypography>
                                    {(iframe) ?this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), n[1]):null}
                                </td>
                            )
                        })}
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{sumNotturno}</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), sumNotturno) : null}
                        </td>
                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?

                            <td>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>{toPrice(sumNotturnoPrezzo)}</MDTypography>
                                {(iframe) ? this.csvAdd(csvOffset + 2 + ((index) * csvNumRow), sumNotturnoPrezzo) : null}
                            </td> : null}
                    </tr>
                    <tr>
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>P</MDTypography>
                            {(iframe) ?this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), ""):null}
                            {(iframe) ?this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), "P"):null}
                        </td>
                        {days.map((el, j) => {
                            let n = this.sumWorkerHours2(worker, j, "PERMESSO");
                            sumPerm += parseFloat(n[0])
                            sumPermPrezzo += parseFloat(n[2])

                            return (
                                <td key={"permesso-" + index + "-" + j}>
                                    <MDTypography variant={"caption"} style={(n[3]<8)?{color:"red", fontWeight:"bold"}:{}}>{n[1]}</MDTypography>
                                    {(iframe) ?this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), n[1]):null}
                                </td>
                            )
                        })}
                        <td>
                            <MDTypography variant={"caption"} fontWeight={"bold"}>{sumPerm}</MDTypography>
                            {(iframe) ? this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), sumPerm) : null}
                        </td>
                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?

                            <td>
                                <MDTypography variant={"caption"} fontWeight={"bold"}>{toPrice(sumPermPrezzo)}</MDTypography>
                                {(iframe) ? this.csvAdd(csvOffset + 3 + ((index) * csvNumRow), sumPermPrezzo) : null}
                            </td>
                            : null
                        }
                    </tr>
                    <tr>
                        <td />
                        {this.rowCommessa(worker, days, index, csvOffset, csvNumRow, iframe)}


                        {/*
                        days.map((el, j) => {
                        let date = new Date(this.state.selectedDay.getFullYear(), this.state.selectedDay.getMonth(), j + 1)
                        date = this.convertDate(date);
                        let commessa = "";
                        if (worker["working-day"][date]) {
                            commessa = worker["working-day"][date][0]["commessa"]
                            lastCommessa=commessa
                        }

                        if(lastCommessa==commessa)

                        return (
                            <td key={"commessa-" + index + "-" + j} >
                                <MDTypography className={styles.mini} variant={"caption"}>{commessa}</MDTypography>
                            </td>
                        )
                    })
                    */}

                        {[ROLES.admin, ROLES.risorse_umane].includes(global.user.ruolo) ?
                            <>
                                <td>
                                    <MDTypography variant={"caption"} fontWeight={"bold"}>
                                        {sumOrd + sumStraord + sumPerm + sumNotturno}
                                    </MDTypography>
                                </td>
                                <td>
                                    <MDTypography variant={"caption"} fontWeight={"bold"}>
                                        {toPrice(sumOrdPrezzo + sumStraordPrezzo + sumPermPrezzo + sumNotturnoPrezzo)}
                                    </MDTypography>
                                </td>
                                {(iframe) ? this.csvAdd(csvOffset + 4 + ((index) * csvNumRow), sumOrd + sumStraord + sumPerm + sumNotturno) : null}
                                {(iframe) ? this.csvAdd(csvOffset + 4 + ((index) * csvNumRow), sumOrdPrezzo + sumStraordPrezzo + sumPermPrezzo + sumNotturnoPrezzo) : null}
                            </>
                            : null
                        }
                    </tr>
                    <tr>
                        <td colSpan={"100%"}>
                            {(iframe) ?this.csvAdd(csvOffset + 5 + ((index) * csvNumRow), ""):null}

                        </td>
                    </tr>
                </tbody>
            </>
        );

        return arr
    }

    rowCommessa = (worker, days, index, csvOffset, csvNumRow, iframe) => {
        let arr = []
        let colspan = 1;
        let lastCommessa = null;

        if (iframe) {
            this.csvAdd(csvOffset + 4 + ((index) * csvNumRow), "")
            this.csvAdd(csvOffset + 4 + ((index) * csvNumRow), "")
            for (let i = 0; i < 31; i++) {
                this.csvAdd(csvOffset + 4 + ((index) * csvNumRow), this.getCommessaOfDay(worker, i)) 
            }
        }

        for (let i = 0; i < days.length; i++) {
            let commessa = this.getCommessaOfDay(worker, i + 1);
            let tomorrowCommessa = this.getCommessaOfDay(worker, i + 2)

            if (commessa == tomorrowCommessa && i < days.length - 1) {
                colspan++;
                continue;
            }

            if (i == 0) {

            }

            arr.push(
                <td key={"commessa-" + i + "-" + worker.id} colspan={colspan}>
                    <MDTypography className={styles.mini} variant={"caption"}>{commessa}</MDTypography>
                </td>
            )
            colspan = 1;
        }

        return arr
    }

    getCommessaOfDay = (worker, day) => {
        let date = new Date(this.state.selectedDay.getFullYear(), this.state.selectedDay.getMonth(), day)
        date = this.convertDate(date);

        if (worker["working-day"][date]) {
            return worker["working-day"][date][0]["commessa"];
        }
        return "";
    }

    sumWorkerHours2 = (worker, index, type)=>{
        let date = new Date(this.state.selectedDay.getFullYear(), this.state.selectedDay.getMonth(), index + 1)
        date = this.convertDate(date);
        if (worker["working-day"][date]) {
            let sum = 0;
            let sumPrice = 0;
            let label = null;
            let totalFiller = 0;
            
            // Calcola il filler totale per questa giornata
            worker["working-day"][date].map((el) => {
                totalFiller += el.filler || 0;
            });
            
            worker["working-day"][date].map((el) => {

                if (type == "ORDINARIO" && el.stato == "FERIE") { label = "F" }
                if (type == "ORDINARIO" && el.stato == "PATERNITA/MATERNITA") { label = "P/M" }
                if (type == "ORDINARIO" && el.stato == "MALATTIA") { label = "M" }
                if (type == "ORDINARIO" && el.stato == "ASSENZA") { label = "A" }
                if (type == "ORDINARIO" && el.stato == "SOSPESO") { label = "S" }

                if (el.stato == type) {
                    // Se è ORDINARIO, aggiungi il filler totale, altrimenti solo le ore
                    sum += type == "ORDINARIO" ? el.ore : el.ore;
                    sumPrice+= newWorkerPrice(el, false)
                }

                if (el.stato == "FERIE" && type == "ORDINARIO") {
                    sum += el.ore;
                    sumPrice += newWorkerPrice(el, false)
                }
                if (el.stato == "MALATTIA" && type == "ORDINARIO") {
                    sum += el.ore;
                    sumPrice += newWorkerPrice(el, false)
                }
                if (el.stato == "SOSPESO" && type == "ORDINARIO") {
                    sum += el.ore;
                    sumPrice += newWorkerPrice(el, false)
                }
                if (el.stato == "ASSENZA" && type == "ORDINARIO") {
                    sum += el.ore;
                    sumPrice += newWorkerPrice(el, false)
                }
                if (el.stato == "PATERNITA/MATERNITA" && type == "ORDINARIO") {
                    sum += el.ore;
                    sumPrice += newWorkerPrice(el, false)
                }

            })
            
            // Aggiungi il filler totale solo alla riga ORDINARIO con il suo costo
            if (type == "ORDINARIO" && totalFiller > 0) {
                sum += totalFiller;
                // Calcola il costo del filler usando sempre il costo ORDINARIO dell'operaio
                let costoFillerTotale = 0;
                worker["working-day"][date].map((el) => {
                    if (el.filler && el.filler > 0) {
                        // Il filler usa sempre il costo ORDINARIO dell'operaio, non il costo specifico del record
                        const costoOrdinario = el.operaio?.costo_orario || el.costo_orario;
                        costoFillerTotale += el.filler * costoOrdinario;
                    }
                });
                sumPrice += costoFillerTotale;
            }
            
            // Calculate total hours for the day
            let totalDayHours = 0;
            worker["working-day"][date].map((el) => {
                totalDayHours += el.ore + el.filler;
            });
            
            if (!label && sum != 0) { 
                label = (totalDayHours < 8 && type !== "NOTTURNO" && type !== "STRAORDINARI ") ? "!" + sum : sum;
            }

            return [sum, label, sumPrice, totalDayHours]
        }
        return [0,"",0]
    }



    print = () => {
        //window.print();
        window.frames["printf"].focus();
        window.frames["printf"].print();

    }

    download = () => {
        var element = document.getElementById('print-table');
        var opt = {
            margin: 1,
            filename: "report " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()+".pdf",
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
            pagebreak: { mode: 'avoid-all' ,before: ['.page-break'] }
        };


        html2pdf(element,opt);
    }




    downloadCSVFile = () => {
        var output = "";
        this.csv.forEach((o, i) => {
            o.forEach((p, j) => {
                output += `"${p}"`;
                if (j < o.length - 1) {
                    output += ",";
                }
            });
            output += "\n";
        });
        let csvData = output;
        let a: any = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        let blob = new Blob([csvData], { type: 'text/csv' });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'report_operai.csv';
        a.click();

        return output;

    }



    render() {

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Report " + monthNames[this.state.selectedDay.getMonth()] + " " + this.state.selectedDay.getFullYear()}
                    subtitle={""}
                    backButton={this.props.backFunction}
                    menu={[{ label: "Stampa", function: this.print }, { label: "Scarica PDF", function: this.download }, { label: "Scarica CSV", function: this.downloadCSVFile }]}
                />

                <MDBox  sx={{ backgroundColor: "white!important", overflowX:"scroll" }} p={3} borderRadius="lg" shadow="lg" >

                    {this.renderCalendar()}

                    {this.state.loading ?
                        <div style={{ textAlign: "center", marginTop: 15 }}><CircularProgress/></div>
                        :
                        <>
                            <IFrame id="printf" name="printf" >
                                <MDTypography className={"onlyPrint"} variant={"h3"}>{monthNames[this.state.selectedDay.getMonth()]}{" "}{this.state.selectedDay.getFullYear()}</MDTypography>
                                <table className={styles.table} cellspacing="0">
                                    {this.state.workers.map((el, index) => {
                                        return this.renderWorkerRow(el, index, true)
                                    })}
                                </table>
                            </IFrame>

                            <table className={styles.table} id="print-table" >
                                {this.state.workers.map((el, index) => {
                                    return this.renderWorkerRow(el, index)
                                })}
                            </table>

                        </>
                    }
                </MDBox>

            </DashboardLayout>
        )
    }

}


